// extracted by mini-css-extract-plugin
export var CtaSectionsContainerCustom = "CallToActionSections-module--CtaSectionsContainerCustom--dcb97";
export var ctaSectionCustom = "CallToActionSections-module--ctaSectionCustom--ab3a5";
export var sectionTitleCustom = "CallToActionSections-module--sectionTitleCustom--7e0d1";